export var WordIndicatorLightCondition;
(function (WordIndicatorLightCondition) {
    /**
     * equal to
     */
    WordIndicatorLightCondition[WordIndicatorLightCondition["Equal"] = 0] = "Equal";
    /**
     * not equal
     */
    WordIndicatorLightCondition[WordIndicatorLightCondition["NotEqual"] = 1] = "NotEqual";
    /**
     * greater than
     */
    WordIndicatorLightCondition[WordIndicatorLightCondition["GreaterThan"] = 2] = "GreaterThan";
    /**
     * less than
     */
    WordIndicatorLightCondition[WordIndicatorLightCondition["LessThan"] = 3] = "LessThan";
    /**
     * greater than or equal to
     */
    WordIndicatorLightCondition[WordIndicatorLightCondition["GreaterOrEqual"] = 4] = "GreaterOrEqual";
    /**
     * less than or equal to
     */
    WordIndicatorLightCondition[WordIndicatorLightCondition["LessOrEqual"] = 5] = "LessOrEqual";
    WordIndicatorLightCondition[WordIndicatorLightCondition["other"] = 6] = "other";
})(WordIndicatorLightCondition || (WordIndicatorLightCondition = {}));
